/**
 * Utilidades de editabilidad de órdenes.
 * Espejo de la lógica del backend OrdenService.es_editable().
 * La fuente de verdad es el campo `es_editable` del API — estas funciones
 * son para UI optimista y visibilidad de controles.
 */

/** Determina si una orden es editable según las reglas de negocio.
 *
 * Si se provee `esEditableApi` (campo del serializer), se usa como fuente de verdad.
 * De lo contrario, se aplica la lógica local como fallback.
 */
export function esOrdenEditable(
  tipoCobro: string | null | undefined,
  estado: string,
  esEditableApi?: boolean
): boolean {
  if (esEditableApi !== undefined) return esEditableApi;
  // Fallback local (sin info de facturas asociadas)
  if (estado === "BAJA") return false;
  if (tipoCobro === "DIRECTO" || tipoCobro === "FACTURA") return false;
  return true;
}

/** Retorna la clave i18n del motivo por el que una orden no es editable, o null si es editable. */
export function getMotivoNoEditable(
  tipoCobro: string | null | undefined,
  estado: string
): string | null {
  if (estado === "BAJA") return "ordenes.edit.notEditable.baja";
  if (tipoCobro === "DIRECTO") return "ordenes.edit.notEditable.pagoDirecto";
  if (tipoCobro === "FACTURA") return "ordenes.edit.notEditable.facturada";
  return null;
}

/** Determina si el botón de editar debe mostrarse.
 * Requiere que la orden sea editable Y que el usuario tenga permiso.
 */
export function shouldShowEditButton(esEditable: boolean, hasPermission: boolean): boolean {
  return esEditable && hasPermission;
}
